<template>
  <div
    v-if="subscription"
    class="od-card-container margin-bottom-8"
  >
    <div class="odc-header-container">
      <div class="odc-header">
        Subscription Details
      </div>
    </div>
    <div class="odc-body-container">
      <table style="width: 100%">
        <thead>
          <tr>
            <th align="left">
              Item
            </th>
            <th align="right">
              Price
            </th>
            <th align="center">
              Qty
            </th>
            <th align="right">
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="odcb-border-container"
          >
            <td>{{ subscription.itemName }}</td>
            <td align="right">
              {{ getAmount(subscription.price) }}
            </td>
            <td align="center">
              {{ subscription.quantity }}
            </td>
            <td align="right">
              {{ getAmount(subscription.total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import partnerReviewMixin from '@shared/mixins/partnerReviewMixin';

export default {
  name: 'OrderSubscription',
  mixins: [partnerReviewMixin],
  data() {
    return {
      description: null,
      price: null,
      qty: null,
      total: null,
    };
  },
  computed: {
    subscription() {
      const subscriptionItem = this.order.orderLines.find((ol) => ol.type.toLowerCase() === 'subscription');
      return subscriptionItem;
    },
  },
};
</script>
